import React from 'react';
import '../less/vacancy.less';
import arrow_back_icon from "../img/arrow_back_icon.svg";
import SendFormModal from "../components/SendModal";
import Preloader from "MWComponents/dest/components/Preloader";
import { recordVideoInterview73, recordVideoInterview85, recordVideoInterview89 } from "../../../services/urls/urls";
import DOMPurify from 'utils/sanitize';

export default function template() {
  const isMobile = this.isViewportMobile(),
    isTablet = this.isViewportTablet(),
    {
      vacancy
    } = this.state,
      id = this.state.id,
    vacancyName = vacancy.name_ua,
    cityName = 'name_ua',
    departmentName = vacancy.department?.name_ua,
    formatName = vacancy.work_type?.name_ua,
    desc = vacancy.desc_ua ? vacancy.desc_ua : '',
    salary = vacancy.salary,
    experience = vacancy.experience_ua ? vacancy.experience_ua : '',
    duties = vacancy.duties ? vacancy.duties : '',
    date = vacancy.date,
    back_btn = <div className="btn-back" onClick={(e) => this.context.app.navigate('/career/vacancies-list', e)}>
      <img src={arrow_back_icon} alt='back'></img> {this.l10n('VACANCY_BTN_BACK')}
  </div>,
    modal = this.state.showModal ? <SendFormModal closeModal={this.toggleModal} vacancyName={vacancyName} vacancyId={id} isMobile={isMobile}></SendFormModal> : '';

    const VACANCY_85 = '85';
    const VACANCY_89 = '89';
    const VACANCY_73 = '73';

    const VIDEO_INTERVIEW_LINKS = {
      [VACANCY_85]: recordVideoInterview85,
      [VACANCY_89]: recordVideoInterview89,
      [VACANCY_73]: recordVideoInterview73,
    };

    const hasVideoInterview = VIDEO_INTERVIEW_LINKS.hasOwnProperty(id);

  return (
    this.state.preload ?
      (<div className="preload-wrapper">
        <Preloader />
      </div>)
      :
    <div className="module-vacancy-container">
      <div className="module-content-wrapper">
        <div className="left-side">
          {isMobile || isTablet ? '' : back_btn}
          <div className="left-side-tags">
            <div className="left-side-tags-item">
              <div className="left-side-tags-item-title">{this.l10n('VACANCY_CITY')}</div>
              <div className="left-side-tags-item-value">
                {vacancy.city.map((cities, index) => (
                    <span key={index}>
                      {`${cities.tags[0][cityName]} ${vacancy.city.length - 1 === index ? '' : ', '} `}
                    </span>
                ))}
              </div>
            </div>
            <div className="left-side-tags-item">
              <div className="left-side-tags-item-title">{this.l10n('VACANCY_DEPARTMENT')}</div>
              <div className="left-side-tags-item-value">{departmentName}</div>
            </div>
            <div className="left-side-tags-item">
              <div className="left-side-tags-item-title">{this.l10n('VACANCY_FORMAT')}</div>
              <div className="left-side-tags-item-value">{formatName}</div>
            </div>
            <div className="left-side-tags-item">
              <div className="left-side-tags-item-title">{this.l10n('VACANCY_DATE')}</div>
              <div className="left-side-tags-item-value">{date}</div>
            </div>
          </div>
          {(!isTablet && !isMobile) && <div className="left-side-send-btn" onClick={this.toggleModal}>{this.l10n('VACANCY_SEND_BACK')}</div>}
          {hasVideoInterview && (
            <>
              <div className="left-side-record-text">{this.l10n('VACANCY_RECORD_TEXT')}</div>
              <a
                rel="noopener noreferrer"
                className="left-side-record-interview"
                href={VIDEO_INTERVIEW_LINKS[id]}
                target="_blank"
              >
                {this.l10n('VACANCY_RECORD_INTERVIEW')}
              </a>
            </>
          )}
        </div>
        <div className="right-side">
          {isMobile || isTablet ? back_btn : ''}
          <div className="right-side-header">
            <div className="right-side-header-title">{vacancyName}</div>
            <div className="right-side-header-salary">
              {salary}
            </div>
          </div>
          {vacancy.block_title && vacancy.block_description ?
            <div className="right-side-requirements">
              <div className="right-side-requirements-title">{vacancy.block_title}</div>
              <div className="right-side-requirements-value" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(vacancy.block_description)}}>
              </div>
            </div> : ''}
          {experience ? (
              <div className="right-side-requirements">
                <div className="right-side-requirements-title">{this.l10n('VACANCY_REQUIREMENTS_TITLE')}</div>
                <div className="right-side-requirements-value" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(experience)}}>
                </div>
              </div>
            ) : ''}
          {duties ? (
              <div className="right-side-requirements">
                <div className="right-side-requirements-title">{this.l10n('VACANCY_DUTIES_TITLE')}</div>
                <div className="right-side-requirements-value" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(duties)}}>
                </div>
              </div>
            ) : ''}
          {desc ? (
              <div className="right-side-requirements">
                <div className="right-side-requirements-title">{this.l10n('VACANCY_CONDITIONS_TITLE')}</div>
                <div className="right-side-requirements-value" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(desc)}}>
                </div>
              </div>
            ) : ''}
        </div>
      </div>
      {(isTablet || isMobile) && <div className="left-side-send-btn left-side-send-btn-tablet" onClick={this.toggleModal}>{this.l10n('VACANCY_SEND_BACK')}</div>}
      {modal}
    </div>
  );
}
